/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Resource } from '../../models/resource';

export interface ResourceControllerReadResource$Params {
  resourceId: string;
}

export function resourceControllerReadResource(http: HttpClient, rootUrl: string, params: ResourceControllerReadResource$Params, context?: HttpContext): Observable<StrictHttpResponse<Resource>> {
  const rb = new RequestBuilder(rootUrl, resourceControllerReadResource.PATH, 'get');
  if (params) {
    rb.path('resourceId', params.resourceId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Resource>;
    })
  );
}

resourceControllerReadResource.PATH = '/resources/{resourceId}';
